import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import Product from '../../../../models/Product';
import { modelOf } from '../../../../prop-types';
import AnalyticsService from '../../../../services/AnalyticsService';
import CheckoutStore from '../../../../store/CheckoutStore';
import { analytics } from '../../../../util/constants';
import AddToCartBasic from '../../../cart/AddToCartBasic';

const CheckoutAddToCart = ({
  analyticsService,
  checkoutStore,
  maxQuantity,
  quantityStep,
  product,
  activeProductId,
  form,
}) => {
  const { addProductToOrder, cartIsLoading, checkoutCartModal } = checkoutStore;

  const disabled =
    !activeProductId ||
    cartIsLoading ||
    product.isTemporarilyUnavailable(activeProductId);
  const quantityField = form.getField('quantity');

  const handleAddToCart = (quantity) => {
    addProductToOrder({ product, quantity, activeProductId }).then(() => {
      analyticsService.addToCart({
        product,
        additionalProps: {
          quantity,
          activeProductId: activeProductId || product.id,
          itemListId: analytics.checkout.checkoutRecommendedProductsListId,
          itemListName: analytics.checkout.checkoutRecommendedProductsListName,
        },
      });
    });

    checkoutCartModal.close();
  };

  return (
    <AddToCartBasic
      product={product}
      field={quantityField}
      quantityStep={quantityStep}
      disabled={disabled}
      maxQuantity={maxQuantity}
      onAddToCartClick={handleAddToCart}
      unit={product.unitName}
    />
  );
};

CheckoutAddToCart.propTypes = {
  analyticsService: PropTypes.instanceOf(AnalyticsService).isRequired,
  checkoutStore: modelOf(CheckoutStore).isRequired,
  // object covers multi subproduct that's not an actual MST-model
  product: PropTypes.oneOfType([modelOf(Product), PropTypes.object]).isRequired,
  activeProductId: PropTypes.string,
};

export default inject(
  'analyticsService',
  'checkoutStore'
)(observer(CheckoutAddToCart));
